import { useState } from 'react';
import { Table } from 'antd';
import { withLocale } from '../../l10n';
import "./DataTable.scss";
import { publish } from '../../utils/events';

function DataTable ({
  columns,
  dataSource = [],
  rowKey,
  rowSelection,
  loading,
  onChange,
  pagination = true,
  scroll = { x: 1500 },
  rowClassName,
  expandable,
  lang
}) {

  // ===== 1. ESTADOS =====
  const [tableState, setTableState] = useState({
    paginationFrom: 1,
    paginationSize: 10,
    dataCurrentSize: null,
    filter: false,
  });

  // ===== 2. DERIVADOS (Computados) =====
  const totalShow = Math.min(tableState.paginationSize, dataSource.length);
  const total = tableState.dataCurrentSize ?? dataSource.length;

  // ===== 3. HANDLERS =====
  const handleTableChange = (paginationObj, filters, sorter, extra) => {
    const arrFilters = Object.values(filters);
    const filter = arrFilters.find(e => e !== null && e.length !== 0);

    const from = (paginationObj.pageSize * (paginationObj.current - 1)) + 1;
    const totalShowObj = Math.min(extra.currentDataSource.length, dataSource.length);
    const totalPages = Math.floor(totalShowObj / paginationObj.pageSize);

    setTableState({
      paginationFrom: from,
      paginationSize: paginationObj.current > totalPages ? totalShowObj : paginationObj.current * paginationObj.pageSize,
      dataCurrentSize: extra.currentDataSource ? extra.currentDataSource.length : dataSource.length,
      filter: filter
    });

    publish('datatable-filter', extra.currentDataSource);

    if (onChange) {
      onChange(paginationObj, filters, sorter, extra);
    }
  };

  // ===== 4. RENDER =====
  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey={(record) => typeof rowKey === 'function' ? rowKey(record) : record[rowKey]}
        rowSelection={rowSelection}
        loading={loading}
        onChange={handleTableChange}
        pagination={pagination}
        scroll={scroll === null ? undefined : scroll}
        rowClassName={rowClassName}
        expandable={expandable}
      />
      {pagination && totalShow > 0 && <div className="counter">
        <span>
          {tableState.paginationFrom + " "}
        </span>
        {"- "}
        <span>
          {totalShow + " "}
        </span>
        <span>
          {lang.handle("de") + " " + total + " "}
        </span>
        {tableState.filter && <span>
          ({lang.handle("filtrados de") + " " + dataSource.length})
        </span>}
      </div>}
    </div>
  );
}

export default withLocale(DataTable);
